'use strict';
'use es6';

/**
 * Determine the proper tabIndex based on the `disabled` and `tabIndex` props. Note that `tabIndex`
 * should not have a default value; it should only be non-null to override normal tabbing behavior.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTabIndex = exports.getTabIndex = function getTabIndex(disabled, tabIndex) {
  var disabledValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

  if (typeof tabIndex === 'number') return tabIndex;
  return disabled ? disabledValue : 0;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/TabIndex.js
// module id = 105
// module chunks = 3 4 5